(() => {
  'use strict';
  const cfg = JSON.parse(document.getElementById('pdp-live-config').textContent);
  const form = document.getElementById('seat-product-form');
  const status = document.getElementById('cart-message');
  const root = document.getElementById('MPTreePdp');
  const buttons = ['add-cart', 'buy-now', 'seat-sticky-add'].map(id => document.getElementById(id));
  const labels = buttons.map(button => button.textContent);
  const route = cfg.root.replace(/\/$/, '');
  let busy = false, uncertain = false;
  const isIce=document.body.dataset.product==='ice';const title=isIce?'Ice Cream Maker Cup':'Heated Poncho';const selected=()=>{const card=root.querySelector('.pack.selected'),qty=Number(card.dataset.qty),colors=[...card.querySelectorAll('select')].map(el=>el.value).sort().join('|');return cfg.variants.find(v=>v.qty===qty&&(!isIce||[...v.colors].sort().join('|')===colors))};

  function message(text = '', error = false) {
    status.hidden = !text;
    status.textContent = text;
    status.setAttribute('role', error ? 'alert' : 'status');
  }
  function sync() {
    const variant = selected();
    form.querySelector('[name=id]').value = variant.id;
    form.querySelector('[name=quantity]').value = 1;
    buttons.forEach((button, i) => {
      button.disabled = busy || !variant.available;
      if (!busy) {
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
        button.textContent = uncertain ? 'Check cart' : variant.available ? labels[i] : 'Unavailable';
      }
    });
  }
  function reset() { busy = false; sync(); }
  root.addEventListener('pdp:selectionchange', sync);
  sync();
  window.addEventListener('pageshow', reset);
  document.querySelectorAll('.seat-country-form select').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));

  // Use the same shared drawer as Christmas lights, including refresh, focus and line editing.
  const bag = [...document.querySelectorAll('header nav a')].find(link => link.pathname === route + '/cart');
  if (bag) {
    bag.setAttribute('role', 'button');
    bag.setAttribute('aria-haspopup', 'dialog');
    bag.addEventListener('click', event => {
      const drawer = document.querySelector('cart-drawer');
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !drawer?.open) return;
      event.preventDefault();
      drawer.open(bag);
    });
    bag.addEventListener('keydown', event => {
      if (event.code === 'Space') { event.preventDefault(); bag.click(); }
    });
  }

  document.getElementById('seat-sticky-add').addEventListener('click',()=>form.requestSubmit(buttons[0]));
  form.addEventListener('submit', async event => {
    event.preventDefault();
    const variant = selected();
    if (busy || !variant.available) return;
    const checkout = event.submitter?.id === 'buy-now';
    const active = buttons.includes(document.activeElement) ? document.activeElement : event.submitter || buttons[0];
    busy = true;
    sync();
    active.classList.add('is-loading');
    active.setAttribute('aria-busy', 'true');
    active.textContent = uncertain ? 'Checking cart…' : checkout ? 'Opening checkout…' : 'Adding…';
    message();
    if (uncertain) {
      try {
        const drawer = document.querySelector('cart-drawer');
        drawer.setActiveElement(active);
        await document.querySelector('mp-cart-panel').refresh();
        uncertain = false;
        reset();
        message('Please review your cart before adding again.');
      } catch { location.assign(route + '/cart'); }
      return;
    }

    // One paid bundle variant, quantity 1: retain the existing fulfillment and discount semantics.
    const qty = variant.qty;
    const colors=isIce?[...root.querySelectorAll('.pack.selected select')].map(el=>el.value):Array(qty).fill('Gray');
    const properties={'Set size':qty+' '+(isIce?(qty===1?'maker':'makers'):(qty===1?'poncho':'ponchos')),'Bundle contents':colors.map(color=>title+' ('+color+(isIce?' · U.S. plug':'')+')').join('; ')};
    colors.forEach((color,i)=>properties['Item '+(i+1)]=color+(isIce?' · U.S. plug':''));
    if(qty>1)properties['Included gift']='1 FREE Mystery Gift per set';
    const body = { items: [{ id: variant.id, quantity: 1, properties }] };
    const drawer = !checkout && document.querySelector('cart-drawer');
    if (drawer?.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(section => section.id);
      body.sections_url = location.pathname;
      drawer.setActiveElement(active);
    }
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    let definitive = false;
    try {
      const response = await fetch(route + '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body), signal: controller.signal
      });
      definitive = response.status >= 400 && response.status < 500;
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'This set could not be added. Please try again.');
      if (drawer?.renderContents && data.sections?.['cart-drawer']) {
        try { drawer.renderContents(data); reset(); return; }
        catch { location.assign(route + '/cart'); return; }
      }
      location.assign(route + (checkout ? '/checkout' : '/cart'));
    } catch (error) {
      uncertain = !definitive;
      reset();
      message(uncertain ? 'Please check your cart before trying again.' : error.message, true);
      if (uncertain) {
        const link = document.createElement('a');
        link.href = route + '/cart';
        link.textContent = ' View cart';
        status.append(link);
      }
    } finally { clearTimeout(timer); }
  });
})();
